import TransferredOrder from '@/models/TransferredOrder';

export default class TransferredOrderRepository {
    public static getAll() {
        return TransferredOrder.query().withAllRecursive().get();
    }
}
